import styled from 'styled-components'

export const FillContainer = styled.div`
  flex: 1;
`

export const FlexContainer = styled.div`
  display: flex;
`

export const Container = styled.div`
  padding-bottom: 64px;
`

export const ContentContainer = styled.div`
  max-width: 780px;
  margin: 0 auto;
  /* padding-left: 2.4rem;
  padding-right: 2.4rem; */

  @media (max-width: 991px) {
    max-width: 780px;
    padding-left: 1.33333rem;
    padding-right: 1.33333rem;
  }
`

export const HeroSection = styled.div`
  padding: 4.8rem 0;

  @media (max-width: 991px) {
    padding: 4.8rem 0;
  }
`

export const OutterContainer = styled.div`
  max-width: 940px;
  margin: 0 auto;
  /* padding-left: 2.4rem;
  padding-right: 2.4rem; */

  @media (max-width: 991px) {
    max-width: 940px;
    padding-left: 1.33333rem;
    padding-right: 1.33333rem;
  }
`

export const ImageContainer = styled.image`
  width: 100%;
`

export const PaymentContainer = styled.div`
  display: flex;
  max-width: 94rem;
  padding: 3.2rem;
  margin: 0 auto;
  margin-top: 4rem;

  @media (max-width: 540px) {
    flex-direction: column-reverse;
    max-width: 540px;
    margin-top: 2rem;
  }
`



// WEBPACK FOOTER //
// ./src/components/Container/containers.js